"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const lodash_1 = require("lodash");
const hooks_1 = require("../../hooks");
function RemoveUserButton({ membershipId, onRemove = lodash_1.noop, }) {
    const sharingService = (0, hooks_1.useSharing)();
    const onRemoveUser = () => {
        /**
         * -1 is identifier of yet to be added membership
         */
        if (membershipId !== -1) {
            sharingService === null || sharingService === void 0 ? void 0 : sharingService.removeUserFromGroup(membershipId);
        }
        onRemove();
    };
    return ((0, jsx_runtime_1.jsx)(DeleteButton, { onClick: onRemoveUser, "data-e2e": 'RemoveUserButton_DeleteButton', children: (0, jsx_runtime_1.jsx)(DeleteButtonIcon, { name: ui_1.Icons.Delete, "data-e2e": 'RemoveUserButton_DeleteButtonIcon' }) }));
}
const DeleteButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  margin: auto 0 auto 20px;
  padding: 5px;

  background: none;
`;
const DeleteButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 20px;
  height: 20px;

  color: ${props => props.theme.text};
`;
exports.default = RemoveUserButton;
